export default values => {
  if (!values.name) return { name: 'Complete el nombre del principio activo' };
  else return {};
};
